import { Injectable } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { UtilityService, HttpClientService } from 'lib/ng2-sapmp/src/providers';
import { throwError } from 'rxjs';

import { HttpResponse } from '@angular/common/http';

@Injectable()
export class BulkUploadService {

  constructor(private utilityService: UtilityService,
    private httpClientService: HttpClientService) { }

  handleError = (error) => {
    return throwError(error);
  }

  uploadFileService(uploadFileData) {
    return this.httpClientService.authorizedMultipartPost(this.utilityService.getEnvConfig().bulkUploadServiceUrl, uploadFileData)
      .pipe(
       map((res: HttpResponse<any>) => {
        this.httpClientService.updateAuthorizationHeaders(res);
        return res.body;
      }
      )
      ,catchError( this.handleError ));
  }
}
